import { GridFilterItem, GridFilterOperator } from "@mui/x-data-grid-pro";
import i18n from "i18next";
import WarningTypeSelect from "../filter/WarningTypeSelect";
import Warning, { WarningType } from "@/models/Warning";

export const WarningTypeFilterOperators: GridFilterOperator[] = [
  {
    label: i18n.t("faultOverview.warningTypeFilter"),
    value: "multiWarningFilter",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value || (filterItem.value as WarningType[]).length === 0) {
        return null;
      }
      return (value?: Warning[]) => {
        const warningTypes = value?.map(w => w.type) || [];
        return (filterItem.value as WarningType[]).some(selectedWarningType =>
          warningTypes.includes(selectedWarningType),
        );
      };
    },
    InputComponent: WarningTypeSelect,
  },
  {
    label: i18n.t("faultOverview.warningTypeNotFilter"),
    value: "notMultiWarningFilter",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value || (filterItem.value as WarningType[]).length === 0) {
        return null;
      }
      return (value?: Warning[]) => {
        const warningTypes = value?.map(w => w.type) || [];
        return !(filterItem.value as WarningType[]).some(selectedWarningType =>
          warningTypes.includes(selectedWarningType),
        );
      };
    },
    InputComponent: WarningTypeSelect,
  },
  {
    label: i18n.t("faultOverview.noWarnings"),
    value: "noWarnings",
    getApplyFilterFn: () => {
      return (value?: Warning[]) => {
        return !value || value.length === 0;
      };
    },
  },
];
